import React from 'react';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { decrement, increment, setQuantity } from '../../../redux/orderSlice';
import { useAppSelector } from '../../../redux/store';
import Images from '../../../Utils/images';
import {
  formatPriceBreakupValues,
  formatToTitleCase,
  getPriceWithCurrency,
} from '../../../Utils/helperFns';
import { RENTAL_SERVICE_TYPE } from '../../../Utils/constantData';
import { useLocation, useNavigate } from 'react-router-dom';

// // Helper for currency formatting
// const getPriceWithCurrency = (price: number) =>
//   price ? `$${price.toFixed(2)}` : '-';

function RenderProductInfo({
  data,
  type,
  rentIndex,
}: {
  data: any;
  type: string;
  rentIndex: number;
}) {
  const dispatch = useDispatch();
  const { quantity } = useAppSelector(state => state.order);
  const navigate = useNavigate();
  const [productType = '', actionType = ''] = (type || '').split('-');
  const actionTypeLc = actionType.toLowerCase();
  const { schdulesTypes } = useAppSelector(state => state.riskCenter);
  const { state } = useLocation();
  // Helper function to get rent offer description texts
  const getRentOfferDescription = (offer: any): React.ReactNode => {
    if (!offer) return null;
    if (!offer.rentPrice || isNaN(Number(offer.rentPrice))) return null;

    const priceStr = (price: any) => getPriceWithCurrency(price || 0);
    if (offer.priceMode === RENTAL_SERVICE_TYPE.PER_HOUR && offer.shiftLength)
      return (
        <>
          {schdulesTypes?.specificRateModel ? (
            <>
              <p className="tag-text MuiTypography-body2">
                <b
                  style={{
                    textDecoration:
                      schdulesTypes?.specificRateModel?.rentPrice <
                      offer.rentPrice
                        ? 'line-through'
                        : 'none',
                    display:
                      !schdulesTypes?.specificRateModel ||
                      schdulesTypes?.specificRateModel?.rentPrice <
                        offer?.rentPrice
                        ? 'block'
                        : 'none',
                  }}
                  className="gray_900 fw600 mr-4"
                >
                  {priceStr(offer.rentPrice)}
                </b>
                <b className="text-gray_900 fw600 mr-4">
                  {priceStr(schdulesTypes?.specificRateModel?.rentPrice)}/hr
                </b>{' '}
                {schdulesTypes?.specificRateModel.shiftLength} hr Rate
                <span>
                  {' '}
                  {schdulesTypes?.specificRateModel.minShiftLength} hr Min
                </span>
              </p>
            </>
          ) : (
            <p className="tag-text MuiTypography-body2">
              <span>
                <b className="text-gray_900 fw600 mr-4">
                  {priceStr(offer.rentPrice)}/hr&nbsp;&nbsp;
                </b>
                {offer.shiftLength} hr Rate
              </span>
              <span> {offer.minShiftLength} hr Min</span>
            </p>
          )}
        </>
      );
    if (offer.minRateModel === 'DAILY') {
      return (
        <>
          {schdulesTypes.specificRateModel ? (
            <>
              <p className="tag-text MuiTypography-body2">
                <b
                  style={{
                    textDecoration:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'line-through'
                        : 'none',
                    display:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'block'
                        : 'none',
                  }}
                  className="gray_900 fw600 mr-4"
                >
                  {priceStr(offer.rentPrice)}
                </b>
                <b className="text-gray_900 fw600">
                  {priceStr(schdulesTypes?.specificRateModel?.rentPrice)}
                </b>

                <span>
                  {' '}
                  {data?.itemType == 'PRODUCT' || data?.itemType == 'PACKAGE'
                    ? schdulesTypes?.specificRateModel?.minDuration > 1
                      ? `${schdulesTypes?.specificRateModel?.minDuration} days`
                      : `${schdulesTypes?.specificRateModel?.minDuration} day`
                    : 'Daily'}
                </span>
              </p>
            </>
          ) : (
            <p className="tag-text MuiTypography-body2">
              <span>
                <b className="text-gray_900 fw600">
                  {priceStr(offer.rentPrice)}
                </b>
              </span>
              <span>
                {data?.itemType == 'PRODUCT' || data?.itemType == 'PACKAGE'
                  ? data?.rentPricing[rentIndex]?.minDuration > 1
                    ? `${data?.rentPricing[rentIndex]?.minDuration} days`
                    : `${data?.rentPricing[rentIndex]?.minDuration} day`
                  : 'Daily'}
              </span>
            </p>
          )}
        </>
      );
    }

    if (offer.minRateModel === 'WEEKLY') {
      return (
        <>
          {schdulesTypes.specificRateModel ? (
            <>
              <p className="tag-text MuiTypography-body2">
                <b
                  style={{
                    textDecoration:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'line-through'
                        : 'none',
                    display:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'block'
                        : 'none',
                  }}
                  className="gray_900 fw600 mr-4"
                >
                  {priceStr(offer.rentPrice)}
                </b>
                <b className="text-gray_900 fw600">
                  {priceStr(schdulesTypes?.specificRateModel?.rentPrice)}
                </b>

                <span>
                  {' '}
                  {data?.itemType == 'PRODUCT' || data?.itemType == 'PACKAGE'
                    ? schdulesTypes?.specificRateModel?.minDuration > 1
                      ? `${schdulesTypes?.specificRateModel?.minDuration} weeks`
                      : `${schdulesTypes?.specificRateModel?.minDuration} week`
                    : 'Weekly'}
                </span>
              </p>
            </>
          ) : (
            <p className="tag-text MuiTypography-body2">
              <span>
                <b className="text-gray_900 fw600">
                  {priceStr(offer.rentPrice)}
                </b>
              </span>

              <span>
                {data?.itemType == 'PRODUCT' || data?.itemType == 'PACKAGE'
                  ? data?.rentPricing[rentIndex]?.minDuration > 1
                    ? `${data?.rentPricing[rentIndex]?.minDuration} weeks`
                    : `${data?.rentPricing[rentIndex]?.minDuration} week`
                  : 'Weekly'}
              </span>
            </p>
          )}
        </>
      );
    }

    if (offer.minRateModel === 'MONTHLY') {
      return (
        <>
          {schdulesTypes.specificRateModel ? (
            <>
              <p className="tag-text MuiTypography-body2">
                <b
                  style={{
                    textDecoration:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'line-through'
                        : 'none',
                    display:
                      schdulesTypes.specificRateModel &&
                      schdulesTypes.specificRateModel?.rentPrice <
                        offer.rentPrice
                        ? 'block'
                        : 'none',
                  }}
                  className="gray_900 fw600 mr-4"
                >
                  {priceStr(offer.rentPrice)}
                </b>
                <b className="text-gray_900 fw600">
                  {priceStr(schdulesTypes?.specificRateModel?.rentPrice)}
                </b>

                <span>
                  {' '}
                  {schdulesTypes?.specificRateModel.minDuration} months
                </span>
              </p>
            </>
          ) : (
            <p className="tag-text MuiTypography-body2">
              <span>
                <b className="text-gray_900 fw600">
                  {priceStr(offer.rentPrice)}
                </b>
              </span>

              <span>{offer.minDuration} months</span>
            </p>
          )}
        </>
      );
    }

    return <>No Data Available</>;
  };

  // // OT and DT Texts
  // const getOTText = (offer: any) => {
  //   if (offer?.OTStartTime) {
  //     return (
  //       <p className="other-charges" style={{ color: '#64748b', marginTop: 8 }}>
  //         Overtime (hours after {offer.OTStartTime} - {offer.DTStartTime})
  //         <span style={{ color: '#000' }}>
  //           :{' '}
  //           {offer.rentPrice ? getPriceWithCurrency(offer.rentPrice * 1.5) : 0}{' '}
  //           per hour
  //         </span>
  //       </p>
  //     );
  //   }
  //   return null;
  // };
  // const getDTText = (offer: any) => {
  //   if (offer?.DTStartTime) {
  //     return (
  //       <p className="other-charges" style={{ color: '#64748b', marginTop: 8 }}>
  //         Double time (hours after {offer.DTStartTime})
  //         <span style={{ color: '#000' }}>
  //           : {offer.rentPrice ? getPriceWithCurrency(offer.rentPrice * 2) : 0}{' '}
  //           per hour
  //         </span>
  //       </p>
  //     );
  //   }
  //   return null;
  // };

  // Build rent prices UI array if renting
  const rentPricesUi =
    actionTypeLc === 'rent' && Array.isArray(data?.rentPricing)
      ? data.rentPricing.map((offer: any, index: number) => {
          return (
            <div key={offer._id || index}>
              {index == rentIndex && getRentOfferDescription(offer)}
              {/* {getOTText(offer)}
              {getDTText(offer)} */}
            </div>
          );
        })
      : [];

  // Build buy price UI if buying
  const buyPriceUi =
    actionTypeLc === 'buy' && data?.finalPrice
      ? [
          <div key="buy">
            <p
              className="MuiTypography-body2 tag-text"
              style={{
                textDecoration:
                  schdulesTypes.specificRatePrice < data.finalPrice
                    ? 'line-through'
                    : 'none',
                display:
                  !schdulesTypes?.specificRatePrice ||
                  schdulesTypes.specificRatePrice < data.finalPrice
                    ? 'block'
                    : 'none',
              }}
            >
              ${formatPriceBreakupValues(data.finalPrice)}
            </p>
          </div>,
          <div>&nbsp;&nbsp;</div>,
          <div>
            {schdulesTypes?.specificRatePrice && (
              <p className="MuiTypography-body2 tag-text">
                ${formatPriceBreakupValues(schdulesTypes.specificRatePrice)}
              </p>
            )}
          </div>,
        ]
      : [];

  const getVariants = () => {
    const variantProps = data?.variantProperties as
      | Record<string, string>
      | undefined;
    const variants = Object.entries(variantProps || {});
    if (variants.length === 0) return null;

    return (
      <p className="tag-text text-gray_400 mb-10">
        {/* First entry */}
        <span>{formatToTitleCase(variants[0][1])}</span>

        {/* Other entries */}
        {variants.slice(1).map(([key, value]) => (
          <span key={key}>{formatToTitleCase(value)}</span>
        ))}
      </p>
    );
  };
  return (
    <>
      <div className="order-service-card">
        <figure
          className="cursor"
          onClick={() =>
            navigate(
              `/store-${productType.toLowerCase()}-details/${data?._id}`,
              { state: { state } },
            )
          }
        >
          <img src={data.thumbnailImg} alt={data.title} />
        </figure>

        <div className="text">
          <h2
            className="MuiTypography-h5 fw600 mb-12 cursor"
            onClick={() =>
              navigate(
                `/store-${productType.toLowerCase()}-details/${data._id}`,
                {
                  state: { state },
                },
              )
            }
          >
            {data?.title}
          </h2>
          {getVariants()}
          <p className="uppercase MuiTypography-body2 text-primary_blue_500 mb-12 ">
            {data?.tags
              ?.split(',')
              .map((tag: any) => tag.trim())
              .join(', ')}
          </p>
          <div className="d-flex" style={{ flexWrap: 'wrap' }}>
            {rentPricesUi.length > 0 ? (
              rentPricesUi
            ) : buyPriceUi.length > 0 ? (
              buyPriceUi
            ) : (
              <p className="MuiTypography-body2 fw600">
                {schdulesTypes?.specificRatePrice
                  ? formatPriceBreakupValues(schdulesTypes.specificRatePrice)
                  : data?.price
                  ? formatPriceBreakupValues(data.price)
                  : 'No data'}
              </p>
            )}
          </div>
        </div>

        <div className="cart-card-right">
          <div className="quantity ml-auto">
            <IconButton onClick={() => dispatch(decrement())}>
              <img src={Images.Minus_Ic} alt="Minus" />
            </IconButton>
            <input
              type="text"
              readOnly
              value={quantity}
              onChange={e => {
                const val = Number(e.target.value);
                if (!isNaN(val) && val >= 0) {
                  dispatch(setQuantity(val));
                }
              }}
            />
            <IconButton onClick={() => dispatch(increment())}>
              <img src={Images.Plus_Ic} alt="Plus" />
            </IconButton>
          </div>
          {data?.publishStatus !== 'PUBLISHED' && (
            <div className="chips unavailable ">
              <span>Unavailable</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RenderProductInfo;
